import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/store';
import persistStore from 'redux-persist/es/persistStore';
import { PersistGate } from 'redux-persist/integration/react';
import { BackContextProvider } from './hooks/context/BackContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const persistor = persistStore(store);
root.render(
  <React.StrictMode>
    <Provider store={store} >
      <PersistGate persistor={persistor}>
        <BackContextProvider>
        <App />
        </BackContextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();